import React from "react";
import { Route } from "react-router-dom";
import AssignLeads from "../../AdminDashboard/ClientReview/AssignLeads/AssignLeads";
import All from "../../AdminDashboard/ClientReview/All/All";
import Messages from "../../AdminDashboard/ClientReview/Messages/Messages";
import NewFile from "../../AdminDashboard/ClientReview/NewFile/NewFile";
import DocsPending from "../../AdminDashboard/ClientReview/DocsPending/DocsPending";
import CallBack from "../../AdminDashboard/ClientReview/CallBack/CallBack";
import CallIndia from "../../AdminDashboard/ClientReview/CallIndia/CallIndia";
import PaymentTrying from "../../AdminDashboard/ClientReview/PaymentTrying/PaymentTrying";
import PaymentRecieved from "../../AdminDashboard/ClientReview/PaymentRecieved/PaymentRecieved";
import Extension from "../../AdminDashboard/ClientReview/Extension/Extension";
import Amendment from "../../AdminDashboard/ClientReview/Amendment/Amendment";
import Notice from "../../AdminDashboard/ClientReview/Notice/Notice";
import NoticeResolved from "../../AdminDashboard/ClientReview/NoticeResolved/NoticeResolved";
import ITINAdmin from "../../AdminDashboard/ClientReview/ITIN/ITIN";
import ClientReview from "../../AdminDashboard/ClientReview/ClientReview";
import Resolve from "../../AdminDashboard/Scheduling/Resolve/Resolve";
import ConnectionsRequired from "../../AdminDashboard/ClientReview/ConnectionsRequired/ConnectionsRequired";
import Accepted from "../../AdminDashboard/ClientReview/Accepted/Accepted";
import CertPending from "../../AdminDashboard/ClientReview/CertPending/CertPending";
import CertDone from "../../AdminDashboard/ClientReview/CertDone/CertDone";
import PaperFile from "../../AdminDashboard/ClientReview/PaperFile/PaperFile";
import Pending8879 from "../../AdminDashboard/ClientReview/8879Pending/8879Pending";
const ClientReviewRoutes = () => {
  return (
    <Route path="client-review" element={<ClientReview />}>
      <Route path="assign-leads" element={<AssignLeads />} />
      <Route path="all" element={<All />} />
      <Route path="messages" element={<Messages />} />
      <Route path="new-file" element={<NewFile />} />
      <Route path="docs-pending" element={<DocsPending />} />
      <Route path="call-back" element={<CallBack />} />
      <Route path="call-india" element={<CallIndia />} />
      <Route path="resolve" element={<Resolve />} />
      <Route path="connections-required" element={<ConnectionsRequired />} />
      <Route path="Accepted" element={<Accepted />} />
      <Route path="payment-trying" element={<PaymentTrying />} />
      <Route path="payment-recieved" element={<PaymentRecieved />} />
      <Route path="cert-pending" element={<CertPending />} />
      <Route path="cert-done" element={<CertDone />} />
      <Route path="paper-file" element={<PaperFile />} />
      <Route path="8879-pending" element={<Pending8879 />} />
      <Route path="extension" element={<Extension />} />
      <Route path="amendment" element={<Amendment />} />
      <Route path="notice" element={<Notice />} />
      <Route path="notice-resolved" element={<NoticeResolved />} />
      <Route path="itin" element={<ITINAdmin />} />
    </Route>
  );
};

export default ClientReviewRoutes;
